$('')

$('body').on('click','#send_form_ser_agencia', function(e) {
    e.preventDefault();

    function check($campo){
        if($campo === ''){
            return false;
        }else{
            return true;                
        }
    }

    nombre          = check($('body').find('input[name=nombre]').val());
    razon_social    = check($('body').find('input[name=razon_social]').val());
    direccion       = check($('body').find('input[name=direccion]').val());
    cif             = check($('body').find('input[name=cif]').val());
    cp              = check($('body').find('input[name=cp]').val());
    fecha_constitucion = check($('body').find('input[name=fecha_constitucion]').val());
    poblacion       = check($('body').find('input[name=poblacion]').val());
    email           = check($('body').find('input[name=email]').val());
    provincia       = check($('body').find('input[name=provincia]').val());
    telefono        = check($('body').find('input[name=telefono]').val());
    persona_contacto = check($('body').find('input[name=persona_contacto]').val());
    fax             = check($('body').find('input[name=fax]').val());
    web             = check($('body').find('input[name=web]').val());
    observaciones   = check($('body').find('textarea[name=observaciones]').val());    
    condiciones     = check($('body').find('input[name=condiciones]').val());
    recibir_noticias = check($('body').find('input[name=recibir_noticias]').val());

    if(check(nombre) == true && check(razon_social) == true && check(direccion) == true 
        && check(cif) == true && check(email) == true && check(telefono) == true && check(persona_contacto) == true  && check(condiciones) == true){
        
        params = {
            'form' : 'MailSerAgencia',
            'nombre'          : $('body').find('input[name=nombre]').val(),
            'razon_social'    : $('body').find('input[name=razon_social]').val(),
            'direccion'       : $('body').find('input[name=direccion]').val(),
            'cif'             : $('body').find('input[name=cif]').val(),
            'cp'             : $('body').find('input[name=cp]').val(),
            'fecha_constitucion' : $('body').find('input[name=fecha_constitucion]').val(),
            'poblacion'       : $('body').find('input[name=poblacion]').val(),
            'email'           : $('body').find('input[name=email]').val(),
            'provincia'       : $('body').find('input[name=provincia]').val(),
            'telefono'        : $('body').find('input[name=telefono]').val(),
            'persona_contacto' : $('body').find('input[name=persona_contacto]').val(),
            'fax'             : $('body').find('input[name=fax]').val(),
            'web'             : $('body').find('input[name=web]').val(),
            'observaciones'   : $('body').find('textarea[name=observaciones]').val(),    
            'condiciones'     : $('body').find('input[name=condiciones]').val(),
            'recibir_noticias' : $('body').find('input[name=recibir_noticias]').val(),
            'g-recaptcha-response': grecaptcha.getResponse()
        };

        var pathname = $(location).attr('href');
        $.ajax({
            url: '/views/layouts/verifica.php',
            type: 'post', 
            dataType: 'json',
            data: params,
            success: function(response) {
                $('#response').html('<p>Gracias, en breve contactaremos contigo.</p>')
                            .removeClass('hidden')              
                            .removeClass('alert-danger')
                            .addClass('alert-success');
            },
            error: function(response) {               
                $('#response').html('<p>Complete el reCAPTCHA</p>')
                              .removeClass('hidden')
                              .addClass('alert-danger')
                              .removeClass('alert-success');
            }
        });
        return false;
    }else{
        $('#response').html('<p>Todos los campos son obligatorios</p>')
                    .removeClass('hidden')
                    .addClass('alert-danger')
                    .removeClass('alert-success');
    }

});


// WEBPACK FOOTER //
// ./assets/js/ser_agencia.js